import { Pipe, PipeTransform } from '@angular/core';

import { contatoTipos } from '../pessoa-contato-tipo';

@Pipe({
    name: 'pessoaContatoTipo'
})
export class PessoaContatoTipoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = contatoTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return contatoTipos[index].nome;
        }
        return '';
    }
}
